import AnnualPeriodsError from './AnnualPeriodsError';
class AnnualPeriodsInvalidCouponId extends AnnualPeriodsError {
    promotionalCouponId;
    constructor(promotionalCouponId, options) {
        super('The Coupon ID is invalid', options);
        this.promotionalCouponId = promotionalCouponId;
    }
}
export default AnnualPeriodsInvalidCouponId;
